import * as api from "api/Knowledge";
import { SpinnerIndicator } from 'components/CallServer';
import MuiContainer from 'components/MuiExtras/MuiContainer';
import MuiWidgetTitle from 'components/MuiExtras/MuiWidgetTitle';
import { TopicRelationship } from 'models/ApiModels';
import * as React from 'react';
import { WithTranslation, withTranslation } from "react-i18next";
import { TopicRelationsRender } from 'views/Topic/Components/TopicRelationsRender';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    data: TopicRelationship[];
    loading: boolean;
}

interface IProps {
    topicId: string;
    timestamp?: Date;
}

type Props = IProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class TopicRelationsWidget extends React.PureComponent<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = {
            data: null,
            loading: true
        };
    }

    ///
    private loadData() {
        api.getTopicRelations(this.props.topicId, 10)
            .then((data: TopicRelationship[]) => {
                this.setState({ data, loading: false });
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    }

    ///
    public componentDidUpdate(prevProps: Props) {
        if (prevProps.timestamp !== this.props.timestamp)
            this.loadData();
    }

    ///
    public componentDidMount() {
        this.loadData();
    }

    ///
    public render() {
        const { data, loading } = this.state;

        return (
            <MuiContainer margin="dense">
                {
                    (loading || data.length > 0) &&
                    <MuiWidgetTitle title={this.props.t("Views.Topic.Widgets.TopicRelationsWidget.BoxTitle")} />
                }

                {
                    loading
                        ? <SpinnerIndicator />
                        : data.length > 0
                            ? <TopicRelationsRender data={data} />
                            : null
                }
            </MuiContainer>
        );
    }
}

export default withTranslation()(TopicRelationsWidget);